<template>
  <div class="w-full body-bg">
    <div class="h-img-block">
      <img class="h-img" src="../assets/2.png" />
    </div>
    <div class="login">
      <div class="login-form">
        <div class="login-form_title">账号注册</div>
        <div>
          <label class="login-form-lable">统一信用代码</label>
          <input
            class="login-form_item margin-top-29"
            placeholder="请设置统一信用代码"
            name="creditCode"
            type="text"
            v-model="creditCode"
          />
        </div>
        <div v-if="wCreditCode" class="font-wraing">
          <img class="wraing-icon" src="../assets/3.png" />
          <span>{{ wCreditCode }}</span>
        </div>
        <div>
          <label class="login-form-lable">单位登录名</label>
          <input
            class="login-form_item margin-top-29"
            placeholder="请设置账号名称"
            name="userName"
            type="text"
            v-model="userName"
          />
        </div>

        <div v-if="wUserName" class="font-wraing">
          <img class="wraing-icon" src="../assets/3.png" />
          <span>{{ wUserName }}</span>
        </div>
        <div>
          <label class="login-form-lable">密码</label>
          <input
            class="login-form_item"
            name="paw"
            placeholder="请输入9~16位密码"
            type="password"
            v-model="paw"
          />
        </div>
        <div v-if="wPaw" class="font-wraing">
          <img class="wraing-icon" src="../assets/3.png" />
          <span>
            {{
            wPaw
            }}
          </span>
        </div>
        <div>
          <label class="login-form-lable">确认密码</label>
          <input
            class="login-form_item"
            name="newPaw"
            placeholder="请输入确认密码"
            type="password"
            v-model="newPaw"
          />
        </div>

        <div v-if="wNewPaw" class="font-wraing">
          <img class="wraing-icon" src="../assets/3.png" />
          <span>
            {{
            wNewPaw
            }}
          </span>
        </div>
        <div>
          <label class="login-form-lable">电子邮箱</label>
          <input
            class="login-form_item"
            name="email"
            placeholder="请输入电子邮箱"
            type="text"
            v-model="email"
          />
        </div>

        <div v-if="wEmail" class="font-wraing">
          <img class="wraing-icon" src="../assets/3.png" />
          <span>
            {{
            wEmail
            }}
          </span>
        </div>
        <div>
          <label class="login-form-lable">负责人手机号</label>
          <input
            class="login-form_item"
            name="tel"
            placeholder="请输入手机号码"
            type="number"
            v-model="tel"
          />
        </div>

        <div v-if="wTel" class="font-wraing">
          <img class="wraing-icon" src="../assets/3.png" />
          <span>
            {{
            wTel
            }}
          </span>
        </div>
        <div class="pos-input">
          <div class>
            <span class="login-form-lable">短信验证</span>
            <input
              class="login-form_item"
              name="code"
              type="number"
              placeholder="请输入短信验证码"
              v-model="code"
            />
          </div>
          <div v-show="!yztg&&show" @click="getCode" class="code-block">发送验证码</div>
          <div v-show="!yztg&&!show" class="code-block">{{count}} s</div>
        </div>
        <div v-if="wCode" class="font-wraing">
          <img class="wraing-icon" src="../assets/3.png" />
          <span>
            {{
            wCode
            }}
          </span>
        </div>
        <div class="createQr">
          未收到验证码?可点击生成二维码后使用微信扫码获取验证码
          <span @click="createQr">生成二维码</span>
        </div>
        <button class="login-but" @click="login">注册</button>
        <div class="login-link">
          <router-link to="/">已有账号？请登录</router-link>
        </div>
        <div
          style="font-size:14px;margin-top:10px;text-algin:center;color:#757575"
        >温馨提示:当前暂无个人账号业务,请勿注册个人账号</div>
      </div>
    </div>
    <div class="qrBox" v-show="isyzm">
      <div class="qrMain">
        <div class="close" @click="isyzm=false"></div>
        <div class="tip">请使用手机微信扫描下方二维码获取验证码</div>
        <div id="qr"></div>
        <div class="place">请输入您在手机端获取的6位数验证码</div>
        <div class="yzm">
          <input type="text" class="yzmipt" maxlength="6" v-model="yzm" />
          <div class="yzwd">
            <div class="yzitem" v-for="(item,index) in 6" :key="index">
              <span>{{returnYzm(index)}}</span>
              <div
                class="line"
                v-show="yzm.length==index"
                :style="yzm.length==index?'animation-play-state:running':'animation-play-state:paused;'"
              ></div>
            </div>
          </div>
        </div>
        <div class="sure" @click="sure">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  IsName,
  IsPaw,
  IsCode,
  IsCreditCode,
  IsPawCompare,
  IsEmail,
  IsTel,
} from "../utils/validate";
import {
  Register,
  SendSms, //发送验证码
} from "../utils/api.js"
import QRCode from "qrcodejs2";
export default {
  name: "Register",
  components: {},
  data () {
    return {
      yztg: false,
      isyzm: false,
      yzm: '',
      userName: "",
      wUserName: "", //用户名提示
      paw: "",
      wPaw: "", //密码提示
      code: "",
      wCode: "", //验证码提示
      newPaw: "",
      wNewPaw: "", //确认密码
      email: "",
      wEmail: "", //电子邮件
      tel: "",
      wTel: "", //手机号码
      pawRemember: false, //是否记住密码
      // 验证码
      show: true,
      count: '',
      timer: null,
      creditCode: "",
      wCreditCode: "", //密码提示
    };
  },
  methods: {
    createQr(){
      if(this.tel==''){
        this.$message({
          message: '请先填写手机号！',
          type: 'error'
        });
        return
      }
      this.isyzm=true
      this.creatQrCode()
      setTimeout(() => {
        document.querySelector('.yzmipt').focus()
      }, 500);
    },
    sure () {
      if (this.yzm.length != 6) {
        this.$message({
          message: '请填写手机获取的6位数的验证码',
          type: 'error'
        });
        return
      }
      this.yztg=true
      this.isyzm=false
      this.code=this.yzm
    },
    returnYzm (index) {
      return this.yzm.split('')[index]
    },
    // 生成二维码
    creatQrCode () {
      document.querySelector('#qr').innerHTML=''
      new QRCode('qr', {
        text: `https://yzm.conjure.net.cn/index.html?phone=${this.tel}&source=1`, // 需要转换为二维码的内容
        width: 230,
        height: 230,
        // render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        colorDark: "#000000", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
      });
    },
    // 发送验证码
    getCode () {
      const TIME_COUNT = 60;
      const data = {
        phone: this.tel
      }
      if (IsTel(this, this.tel, "手机号码")) {
        SendSms(data).then(res => {
          console.log(res)
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000)
          }
        }).catch(err => {
          this.$message.error(err);
        })
      }


    },
    onRegisterTap () {
      this.$router.push({
        name: "Register"
      });
    },
    login () {
      console.log('this.creditCode', this.creditCode)
      if (
        IsCreditCode(this, this.creditCode, "统一社会信用代码") &&
        IsName(this, this.userName, "单位登录名") &&
        IsPaw(this, this.paw, "登录密码") &&
        IsPawCompare(this, this.newPaw, "确认密码", this.paw) &&
        IsEmail(this, this.email, "电子邮箱") &&
        IsTel(this, this.tel, "负责人手机号码") &&
        IsCode(this, this.code, "验证码")


      ) {
        console.log("校验通过");
        let type=1
        if(this.yztg){type=2}
        const data = {
          "name": this.userName,
          "password": this.paw,
          "phone": this.tel,
          "email": this.email,
          "code": this.code,
          "creditCode": this.creditCode,
          "type": type
        }
        Register(data).then(res => {
          console.log(res)
          this.$message({
            message: '注册成功',
            type: 'success'
          });

        }).catch(err => {
          this.$message.error(err);
        })
      }
    },
  },
};
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
}

body {
  width: 100%;
  height: 100%;
}
.qrBox {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #000000b4;
  z-index: 999;
  position: fixed;
  .qrMain {
    width: 620px;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: #fff;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding-top: 40px;
    .close{
      position: absolute;
      right: 20px;
      top: 20px;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
    .close::after{
      position: absolute;
      width: 90%;
      height: 2px;
      background-color: #686666;
      display: block;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) rotate(45deg);
    }
    .close::before{
      position: absolute;
      width: 90%;
      height: 2px;
      background-color: #686666;
      display: block;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) rotate(-45deg);
    }
    .tip {
      font-size: 20px;
      color: #000000;
    }
    #qr {
      margin: 0 auto;
      margin-top: 26px;
      width: 230px;
    }
    .place {
      margin-top: 40px;
      font-size: 16px;
      color: #262626;
    }
    .yzm {
      margin: 0 auto;
      width: 400px;
      margin-top: 25px;
      height: 64px;
      position: relative;
      input {
        text-indent: 1em;
        width: 100%;
        height: 100%;
        font-size: 30px;
        letter-spacing: 46px;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        z-index: 2;
      }
      .yzwd {
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: space-evenly;
        .yzitem {
          width: 48px;
          font-size: 30px;
          height: 66px;
          background: #f0f4fc;
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #2e60d9;
          text-align: center;
          line-height: 64px;

          position: relative;
          .line {
            position: absolute;
            left: 50%;
            bottom: 4px;
            transform: translateX(-50%);
            width: 80%;
            height: 2px;
            background-color: #686868;
            animation: ss 2s linear infinite;
          }
          @keyframes ss {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0.2;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
    .sure {
      margin: 0 auto;
      margin-top: 40px;
      width: 378px;
      height: 48px;
      background: #02318f;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 48px;
      border-radius: 4px 4px 4px 4px;
      cursor: pointer;
    }
  }
}
.w-full {
  width: 100%;
  height: 100%;
}
.createQr {
  margin-top: 20px;
  font-size: 14px;
  color: #595959;
  span {
    cursor: pointer;
    color: #02318f;
    text-decoration-line: underline;
  }
}

.body-bg {
  background: url("../assets/1.png");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  height: 100%;

  .h-img-block {
    margin-top: 59px;
    text-align: center;

    .h-img {
      width: 396px;
      // height: 123px;
    }
  }

  .login {
    // margin-top: 43px;

    .login-form {
      width: 658px;
      //  height: 473px;
      background: #fff;
      margin: 0 auto;
      padding: 20px 20px 40px 22px;

      .login-form-lable {
        display: inline-block;
        width: 90px;
        color: #757575;
        font-size: 14px;
        text-align: right;
      }

      &_title {
        color: #272f3c;
        font-size: 24px;
        font-weight: bold;
        line-height: 26px;
        text-align: left;
        border-bottom: 1px solid #dbdbdb;
        padding-bottom: 18px;
      }

      &_item {
        width: 280px;
        height: 42px;
        border: 1px solid #bdc3cb;
        padding: 0px 11px;
        font-size: 14px;
        margin-left: 12px;
        margin-top: 10px;
      }

      .margin-top-29 {
        margin-top: 29px;
      }

      .pos-input {
        position: relative;

        .margin-top-0 {
          margin-top: 0px;
        }

        .code-block {
          position: absolute;
          top: 10px;
          right: 140px;
          width: 102px;
          height: 42px;
          text-align: center;
          line-height: 42px;
          color: #194abe;
          border: 1px solid #194abe;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .login-form_assist {
        width: 280px;
        //   height: 60px;
        //  line-height: 60px;
        margin-top: 15px;
        // margin-left: 32px;
        margin-bottom: 19px;
        vertical-align: middle;

        &_isAgree {
          display: inline-block;

          margin-right: 8px;
        }

        &_isAgree:checked::after {
          background: crimson;
        }

        a {
          float: right;
          text-decoration: underline;
          color: #71767c;
          font-size: 14px;
        }
      }

      .login-but {
        width: 302px;
        height: 48px;
        background: #194abe;
        opacity: 1;
        border-radius: 6px;
        // margin-left: 32px;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border: none;
        cursor: pointer;

        margin-left: 70px;
        margin-top: 37px;
      }

      .login-register {
        width: 280px;
        height: 48px;
        background: #ffffff;
        opacity: 1;
        border-radius: 6px;
        // margin-left: 32px;
        color: #194abe;
        font-size: 16px;
        font-weight: bold;
        margin-top: 24px;
        text-align: center;
        line-height: 48px;
        border: 1px solid #194abe;
        cursor: pointer;
        border-radius: 6px;
      }

      .font-wraing {
        color: #ff7476;
        font-size: 14px;
        margin-left: 210px;
        margin-top: 6px;
        text-align: left;
      }

      .wraing-icon {
        display: inline-block;
        margin-right: 10px;
      }
    }
  }

  .login-link {
    font-size: 16px;
    color: #194abe;
    margin-top: 14px;
    margin-left: 70px;
    font-weight: 400;
  }
}
</style>
